import React from 'react';
import cn from 'classnames';
import styles from './CallToActionGroup.module.scss';
import { HubModuleCTA } from '../../../../types';
import { CallToAction } from './CallToAction';

export * from './CallToAction';

export interface CallToActionGroupProps
  extends React.BaseHTMLAttributes<HTMLDivElement> {
  primary: HubModuleCTA;
  secondary?: HubModuleCTA;
  moduleType: string;
}

export function CallToActionGroup(props: CallToActionGroupProps) {
  const { primary, secondary, className, moduleType, ...attrs } = props;

  if (!primary.shown && !secondary?.shown) {
    return null;
  }

  return (
    <div className={cn(styles.wrapper, className)} {...attrs}>
      {primary.shown && (
        <CallToAction
          link={primary}
          variant="contained"
          ga4={{
            module_type: moduleType,
            cta_type: 'primary',
          }}
        />
      )}
      {secondary?.shown && (
        <CallToAction
          link={secondary}
          variant="outlined"
          ga4={{
            module_type: moduleType,
            cta_type: 'secondary',
          }}
        />
      )}
    </div>
  );
}
